
const rawApiUrl = process.env.VUE_APP_BASE_URL || ''

export const API_URL = rawApiUrl.replace(/\/+$/, '')
